<template>
	<div v-loading="loading">
		<card-box class="mySeal" title="问题反馈">
			<el-form  :model="new_contact" ref="new_contact" label-width="100px" class="from_list" :rules="companyAuthInfo_rules">
				<el-form-item label="问题类型" prop="radio">
					<el-radio-group v-model="new_contact.radio">
						<el-radio :label="item.code" :key="item.code" v-for="item in sttusCode">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="具体内容" prop="context">
					<el-input type="textarea" v-model="new_contact.context" :rows="4" placeholder="请输入您需要反馈的具体内容"  maxlength="400"></el-input>
					<div class="from_test">注：问题的回复工作时间为：周一至周五，9:00至18:00，请耐心等待工作人员回复。(最多可输入400个字)</div>
				</el-form-item>
				<el-form-item class="from_div">
					<el-button :loading="loding_s" class="from_button" type="primary" @click="getDoc('new_contact')"> 提交</el-button>
				</el-form-item>
			</el-form>

		</card-box>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				new_contact:{
					radio: "2000"
				},
				user:this.$SIF.getLocalStorage("userInfo"),
				sttusCode:{},
				loading:false,
				companyAuthInfo_rules:{
					radio: [
						{
							required: true,
							message: "请选择活动性质",
							trigger: "blur"
						}
					],
					context: [
						{
							required: true,
							message: "请输入具体内容",
							trigger: "blur"
						}
					],
				},
				loding_s:false,
			};
		},
		created() {
			this.loading = true
			this.$SIF.httpPost({
				url: this.$SIF._serve.menhu + "/code/query",
				data: {
					typeClass: "feedbackType"
				},
				succFun: res => {
					this.sttusCode = res.data;
					this.loading=false
				},
				failFun:res=>{
					this.loading = false
				}
			});
		},
		components: {

		},
		methods: {
			getDoc(new_contact) {
				this.$refs[new_contact].validate((valid) => {
					if (valid) {
						this.loding_s = true
						this.$SIF.httpPost({
							url:  this.$SIF._serve.menhu + "/feedback/save",
							data: {
								"company": "",
								"context": this.new_contact.context,
								"email": this.user.authenEmail,
								"phone": this.user.contactPhone,
								"type": this.new_contact.radio,
								"createBy":this.user.id,
								"userName": this.user.userName,
								"userAccount":this.user.userAccount
							},
							succFun: res => {
								if (res.code == 10000) {
									this.new_contact.context = '';
									this.loding_s = false
									this.$message({
										message: res.msg,
										type: "success"
									});
								} else {
									this.loding_s = false
									this.$message({
										message: res.msg,
										type: "warning"
									});
								}
							}
						});
					} else {
						return;
					}
				});

			}
		}
	};
</script>

<style>
	.from_list{
		width: 80%;
		margin: 0 auto;
		padding: 20px 0;
	}
	.from_div{
		width: 100%;
		text-align: center;
		padding-bottom: 30px;
	}
	.from_test{
		color: #6A6A6A;
		font-size: 12px;
	}
</style>